module.exports = __webpack_public_path__ + "static/media/heart9.7bd4fb6a.svg";